
// 聊天窗口页面——主流程
const MainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `page/chatWindow/index${i + 1}`,
  name: `page/chatWindowIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/chatWindow/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 聊天窗口页面——主流程，开始
    ...MainRoutes
  ]
}
